var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Actions from '../actions/user.actions';
import * as TranslationActions from '../../../translation/store/actions';
var initialState = {
    role: 'guest',
    data: {
        displayName: '',
        photoURL: '',
        email: '',
    },
    profile: {},
    settings: {},
    externalOrgsUserHasAccessTo: [],
};
var user = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case Actions.SET_USER_DATA: {
            return __assign(__assign({}, initialState), action.payload);
        }
        case Actions.SET_PROFILE_DATA: {
            return __assign(__assign({}, state), { profile: action.payload });
        }
        case Actions.REMOVE_USER_DATA: {
            return __assign({}, initialState);
        }
        case Actions.USER_LOGGED_OUT: {
            return initialState;
        }
        case Actions.USER_CHANGE_TOOLTIP_SETTINGS: {
            return __assign(__assign({}, state), { settings: __assign(__assign({}, state.settings), { isFirstLogin: false, tooltipDisabled: action.payload.tooltipDisabled }) });
        }
        case TranslationActions.CHANGE_LANG: {
            return __assign(__assign({}, state), { settings: __assign(__assign({}, state.settings), { preferredLanguage: action.payload.lang }) });
        }
        case Actions.SET_USER_CONFIGURATION_DATA: {
            return __assign(__assign({}, state), { settings: __assign(__assign({}, state.settings), { isConfigurationCompleted: true }) });
        }
        case Actions.UPDATE_USER_AUTO_PLAY_SETTING: {
            return __assign(__assign({}, state), { settings: __assign(__assign({}, state.settings), { autoPlay: action.payload.isAutoPlay }) });
        }
        default: {
            return state;
        }
    }
};
export default user;



//////////////////
// WEBPACK FOOTER
// ./src/auth/store/reducers/user.reducer.ts
// module id = 1463
// module chunks = 81